import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
    Navigate,
} from "react-router-dom";

import ProtectedRoutesWrapper from "../components/Security/ProtectedRoutesWrapper";
import AccessDenied from "../components/Security/AccesDenied";
import loadable from "@loadable/component";

//layout
import Main from "../layouts/Main";
//loaders
import { concertLoader, reviewLoader, reviewDetailLoader, eventDetailsLoader } from "./loader.js";
import MoreNewVideos from "../views/Magazine/NewsDeployment/MoreNewVideos/MoreNewVideos.jsx";
import LugaresHome from "../views/Magazine/NewsDeployment/MorePopularOfWeek/sliceCharts.jsx";


// views
const CoverageTrendsDetails = loadable(
    () => import("../views/Magazine/CoverageTrendsDetails/CoverageTrendsDetails"),
);
const Home = loadable(() => import("../views/Home/Home"));
const Streaming = loadable(() => import("../views/Streaming/Streaming"));
const Artist = loadable(() => import("../views/Artist/Artist"));
const Store = loadable(() => import("../views/Store/Store"));
const SignUp = loadable(() => import("../views/Auth/SignUp"));
const SignIn = loadable(() => import("../views/Auth/SignIn"));
const SignOut = loadable(() => import("../views/Auth/SignOut"));
const ConfirmEmail = loadable(() => import("../views/Auth/ConfirmEmail"));
const RecoverPassword = loadable(() => import("../views/Auth/RecoverPassword"));
const RequestPasswordRecovery = loadable(() => import("../views/Auth/RequestPasswordRecovery"));
const NotFound = loadable(() => import("../views/NotFound/NotFound"));
const TV = loadable(() => import("../views/Tv/TV"));
const MainTV = loadable(() => import("../views/Tv/Main/Main"));
const Magazine = loadable(() => import("../views/Magazine/Magazine"));
const DetailsCategory = loadable(() => import("../views/Store/Details/DetailsCategory"));
const DetailsProduct = loadable(() => import("../views/Store/Details/DetailsProduct"));
const ConcertsView = loadable(() => import("../views/Concerts/ConcertsView"));
const CrowdFunding = loadable(() => import("../views/CrowdFunding/CrowdFunding"));
const Profile = loadable(() => import("../views/ArtisProfile/ArtisProfile"));
const CommunityProfile = loadable(() => import("../views/CommunityProfile/CommunityProfile"));
const TemplatePerfil1 = loadable(() => import("../views/TemplatePerfil1/TemplatePerfil1.jsx"));
const TemplatePerfil2 = loadable(() => import("../views/TemplatePerfil2/TemplatePerfil2"));
const TemplatePerfil3 = loadable(() => import("../views/TemplatePerfil3/TemplatePerfil3"));
const ProPerfil1 = loadable(() => import("../views/ProfessionalProfile/Perfil1/Perfil1"));
const ProPerfil2 = loadable(() => import("../views/ProfessionalProfile/Perfil2/Perfil2"));
const ProPerfil3 = loadable(() => import("../views/ProfessionalProfile/Perfil3/Perfil3"));
const TemplateProfessionalPerfil1 = loadable(
    () => import("../views/TemplateProfessionalProfile/Perfil1/TemplateProPerfil1.jsx"),
);
const TemplateProfessionalPerfil2 = loadable(
    () => import("../views/TemplateProfessionalProfile/Perfil2/TemplateProPerfil2.jsx"),
);
const TemplateProfessionalPerfil3 = loadable(
    () => import("../views/TemplateProfessionalProfile/Perfil3/TemplateProPerfil3.jsx"),
);
const ProfileData = loadable(() => import("../views/ProfileData/ProfileData"));
const ArtistDashboard = loadable(() => import("../views/ArtistDashboard/ArtistDashboard"));
const EventDetails = loadable(() => import("../views/Store/Events/EventDetails"));
const Classes = loadable(() => import("../views/Classes/Classes"));
const NewsDeployment = loadable(() => import("../views/Magazine/NewsDeployment/NewsDeployment"));
const TrendNews = loadable(() => import("../views/Trend/TrendNews"));
const NewsGet = loadable(() => import("../views/Magazine/NewsDeployment/NewsGet/NewsGet"));
const NewsHybridGet = loadable(() => import("../views/Magazine/NewsDeployment/NewsGet/NewsHybridGet"));
const NewsCreator = loadable(() => import("../views/Magazine/NewsDeployment/NewsCreator/NewsCreator"));
const NewsEdit = loadable(() => import("../views/Magazine/NewsDeployment/NewsEdit/NewsEdit"));
const MoreNews = loadable(() => import("../views/Magazine/NewsDeployment/MoreNews/MoreNews"));
const MoreMain = loadable(() => import("../views/Magazine/NewsDeployment/MoreMain/MoreMain"));
const TestEnviroment = loadable(() => import("../components/NewsCard/TestEnviroment"));
const Search = loadable(() => import("../views/Search/Search"));
const Comment = loadable(() => import("../views/Comment/Comment.jsx"));
const CommentUserPost = loadable(() => import("../views/Comment/CommentUserPost.jsx"));
const Comunity = loadable(() => import("../views/Comunity/Comunity.jsx"));
const Review = loadable(() => import("../views/Reviews/Review.jsx"));
const ReviewDetailsPage = loadable(() => import("../views/Reviews/ReviewDetailsPage.jsx"));
const ChangePassword = loadable(() => import("../views/Auth/ChangePassword.jsx"));

const EventsLayout = loadable(() => import("../views/Events/EventsLayout.jsx"));
const EventsSearch = loadable(() => import("../views/Events/Search/SearchLayout.jsx"));
const EventDetailsLayout = loadable(() => import("../views/Events/Details/EventDetailsLayout.jsx"));
const MoreShowbiz = loadable(() => import("../views/Magazine/NewsDeployment/MoreShowbiz/MoreShowbiz"));
const MoreDebates = loadable(() => import("../views/Magazine/NewsDeployment/MoreDebates/MoreDebates"));
const MoreStories = loadable(() => import("../views/Magazine/NewsDeployment/MoreStories/MoreStories"));
const MoreTeleRevista = loadable(
    () => import("../views/Magazine/NewsDeployment/MoreTeleRevista/MoreTeleRevista"),
);
const MoreNewLatinMusic = loadable(
    () => import("../views/Magazine/NewsDeployment/MoreNewLatinMusic/MoreNewLatinMusic.jsx"),
);
const MoreRecommendation = loadable(
    () => import("../views/Magazine/NewsDeployment/MoreRecommendation/MoreRecommendation.jsx"),
);
const RecordingsPage = loadable(
    () => import("../views/Magazine/NewsDeployment/RecordingsPage/RecordingsPage"),
);
const EventNewsPage = loadable(
    () => import("../views/Magazine/NewsDeployment/EventNewsPage/EventNewsPage"),
);
const ForumForDiscussions = loadable(() => import("../views/ForumForDiscussions/ForumForDiscussions"));
const OpinionsImplementation = loadable(
    () => import("../views/Magazine/OpinionsImplementation/OpinionsImplementation"),
);
const Chat = loadable(() => import("../views/Chat/Chat"));
const AudioVideoCall = loadable(() => import("../views/AudioVideoCall/AudioVideoCall"));
const SuccessPaymentProduct = loadable(
    () => import("../views/Store/SuccessPayment/SuccessPaymentProduct"),
);
const SuccessPaymentTicket = loadable(
    () => import("../views/Store/SuccessPayment/SuccessPaymentTicket"),
);
const SuccessPaymentCrowdFunding = loadable(
    () => import("../views/Store/SuccessPayment/SuccessPaymentCrowdFunding"),
);
const LayoutEditorialEvents = loadable(() => import("../views/Editorial/eventos/Layout.jsx"));
const LayoutEditorialPagos = loadable(() => import("../views/Editorial/pagos/Layout.jsx"));
const TabCharts = loadable(
    () => import("../../src/components/Editorial/tabs/tabsCharts/TabCharts.jsx"),
);
const ModuleCharts = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/ModuleCharts.jsx"),
);
const MoreSongCharts = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/MoreSongCharts.jsx"),
);
const MoreArtistCharts = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/MoreArtistCharts.jsx"),
);
const MoreSongDailyCharts = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/MoreSongDailyCharts.jsx"),
);
const TopViewShareCard = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/TopViewShareCard.jsx"),
);
const TopViewShareArtistCard = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/TopViewShareArtistCard.jsx"),
);
const TopViewShareMainCard = loadable(
    () => import("../views/Magazine/NewsDeployment/MorePopularOfWeek/TopViewShareMainCard.jsx"),
);
const ClassifiedTab = loadable(
    () => import("../components/Editorial/tabs/ClassifiedTab/ClassifiedTab.jsx"),
);
const DashboardView = loadable(() => import("../views/Editorial/dashboard"));
const DetailsProject = loadable(() => import("../views/CrowdFunding/Details/DetailsProject"));
const NewsSelectionTab = loadable(() => import("../components/Editorial/tabs/NewsSelectionTab"));
const TVStreaming = loadable(() => import("../views/Tv/TVStreaming/TVStreaming"));
const TemplateUserProfile1 = loadable(
    () => import("../views/TemplateUserProfile/TemplateUserProfile1/TemplateUserProfile1.jsx"),
);
const TemplateUserProfile2 = loadable(
    () => import("../views/TemplateUserProfile/TemplateUserProfile2/TemplateUserProfile2.jsx"),
);
const TemplateUserProfile3 = loadable(
    () => import("../views/TemplateUserProfile/TemplateUserProfile3/TemplateUserProfile3.jsx"),
);
const TemplateCommunity = loadable(
    () => import("../views/TemplateCommunityProfile/TemplateCommunityProfile.jsx"),
);
const Privacity = loadable(() => import("../views/Privacity/Privacity.jsx"));
const LayoutSugerenciasStreaming = loadable(
    () => import("../views/Streaming/LayoutSugerenciasStreaming.jsx"),
);
const PaypalSuccess = loadable(() => import("../views/Pays/Paypal/PaypalSuccess.jsx"));
const PaypalCancel = loadable(() => import("../views/Pays/Paypal/PaypalCancel.jsx"));
const StripeSuccess = loadable(() => import("../views/Pays/Stripe/StripeSuccess.jsx"));
const StripeCancel = loadable(() => import("../views/Pays/Stripe/StripeCancel.jsx"));
const ClassifiedModule = loadable(() => import("../components/ClassifiedModule/ClassifiedModule.jsx"));
const ClassifiedDetails = loadable(
    () => import("../components/ClassifiedModule/ClassifiedDetails.jsx"),
);
const AltaRadio = loadable(
    () => import("../views/Radio/Radio.jsx"),
);

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<Main />}>
                <Route path="denied" element={<AccessDenied />} />
                <Route path="privacidad" element={<Privacity />} />

                {/* -- Cambio de ruta temporal para mostrar la seccion noticias como pagina inicial -- */}
                {/* <Route index element={<Home />} /> */}
                <Route index element={<Home />} />

                <Route
                    path="editorial"
                    element={
                        <ProtectedRoutesWrapper
                            definedPath={"/editorial"}
                            redirectPath={"../auth"}
                            deniedPath={"../denied"}
                        />
                    }
                >
                    <Route path="main" element={<NewsSelectionTab />} />
                    <Route path="control" element={<DashboardView />} />
                    <Route path="eventos" element={<LayoutEditorialEvents />} />
                    <Route path="pagos" element={<LayoutEditorialPagos />} />
                    <Route path="charts" element={<TabCharts />} />
                    <Route path="clasificados" element={<ClassifiedTab />} />
                </Route>
                <Route
                    path="/perfil"
                    element={
                        <ProtectedRoutesWrapper
                            definedPath={"/perfil"}
                            redirectPath={"../auth"}
                            deniedPath={"../denied"}
                        />
                    }
                >
                    <Route path="/perfil/cambiar-contrasena" element={<ChangePassword />} />
                </Route>
                <Route path="/charts">
                    {/*<Route
                        index
                        element={
                            <LugaresHome
                                header="Alta-Voz Chart"
                                slice1="0"
                                slice2="2"
                                slice3="0"
                                slice4="5"
                                slice5="2"
                                slice6="12"
                                slice7="5"
                                slice8="15"
                            />
                        }
                    />*/}
                    <Route index element={<ModuleCharts />} />
                    <Route path="/charts/top-canciones" element={<MoreSongCharts />} />
                    <Route path="/charts/top-artistas" element={<MoreArtistCharts />} />
                    <Route path="/charts/top-diario-canciones" element={<MoreSongDailyCharts />} />
                </Route>
                <Route path="/streaming">
                    <Route index element={<Streaming />} />
                    <Route
                        path="/streaming/:id/:formatArtistNameForURL?"
                        element={<LayoutSugerenciasStreaming />}
                    />
                </Route>
                <Route path="/radio">
                    <Route index element={<AltaRadio />} />
                </Route>
                <Route path="/artist" element={<Artist />} />
                <Route path="/store">
                    <Route index element={<Store />}></Route>
                    <Route path="/store/details/:id">
                        <Route index element={<DetailsCategory />} />
                        <Route path="/store/details/:id/:productID" element={<DetailsProduct />} />
                    </Route>
                    <Route path="/store/event/:eventID" element={<EventDetails />} />
                </Route>
                <Route
                    path="/news_panel"
                    element={
                        <ProtectedRoutesWrapper
                            redirectPath={"../auth"}
                            deniedPath={"../denied"}
                            definedPath={"/news_panel"}
                        />
                    }
                >
                    <Route path="/news_panel/create" element={<NewsCreator />} />
                    <Route path="/news_panel/edit/:id" element={<NewsEdit />} />
                </Route>
                <Route path="altavoztv" element={<TVStreaming />} />
                <Route path="noticias">
                    <Route index element={<NewsDeployment />} />
                    <Route path="grabaciones-lanzamientos" element={<RecordingsPage />} />

                    <Route path="eventos" element={<EventNewsPage />} />
                    <Route path="historias" element={<MoreStories />} />
                    <Route path="farandula" element={<MoreShowbiz />} />
                    <Route path="principales" element={<MoreMain />} />
                    <Route path="ultimahora" element={<MoreNews />} />
                    <Route path="musicalatina" element={<MoreNewLatinMusic />} />
                    <Route path="musicarecomendacion" element={<MoreRecommendation />} />
                    <Route path="nuevosvideos" element={<MoreNewVideos />} />
                    <Route path="tendencias/:id" element={<TrendNews />} />
                    <Route path="recomendaciones">
                        <Route index element={<Review />} loader={reviewLoader} />
                        <Route path=":id" element={<ReviewDetailsPage />} loader={reviewDetailLoader} />
                    </Route>
                </Route>
                <Route path="/buscar/" element={<Search />} />
                <Route path="/test-newsimagecard" element={<TestEnviroment />} />
                <Route path="/news_get/:id" element={<NewsGet />} />
                <Route path="/news_get/hn/:id" element={<NewsHybridGet />} />
                <Route path="/news" element={<Magazine />} />
                <Route path="/more_debates" element={<MoreDebates />} />
                <Route path="/more_tele_revista" element={<MoreTeleRevista />} />
                <Route path="/opinions_all" element={<OpinionsImplementation />} />
                <Route path="/forum/:id" element={<ForumForDiscussions />} />
                <Route path="/trends_all" element={<CoverageTrendsDetails />} />
                <Route path="/details/" element={<Magazine />} />
                <Route path="/conciertos">
                    <Route index element={<EventsLayout />} loader={concertLoader} />
                    <Route path="encuentra-tu-evento" element={<EventsSearch />} />
                    <Route path=":id" element={<EventDetailsLayout />} loader={eventDetailsLoader} />
                </Route>
                <Route path="/classes" element={<Classes />} />
                <Route path="/financiamiento">
                    <Route index element={<CrowdFunding />} />
                    <Route path="/financiamiento/projects/:id" element={<DetailsProject />} />
                </Route>
                <Route path="/clasificados/:tab?" element={<ClassifiedModule />} />
                <Route
                    path="/clasificados/detalles/:id/:formatTitleForURL?"
                    element={<ClassifiedDetails />}
                />
                <Route path="/pagos">
                    <Route path="/pagos/paypal/confirmado" element={<PaypalSuccess />} />
                    <Route path="/pagos/paypal/cancelado" element={<PaypalCancel />} />
                    <Route path="/pagos/stripe/confirmado" element={<StripeSuccess />} />
                    <Route path="/pagos/stripe/cancelado" element={<StripeCancel />} />
                </Route>
                <Route path="/profileform" element={<ProfileData />} />
                <Route path="/dashboard-artist" element={<ArtistDashboard />} />
                <Route path="/chat" element={<Chat />} />
                <Route path="/audio_video_call" element={<AudioVideoCall />} />
                <Route path="/comunidad">
                    <Route index element={<Comunity />} />
                    <Route path="/comunidad/publicaciones/:id" element={<CommentUserPost />} />
                    <Route path="/comunidad/:type/:id/:formatArtistNameForURL?" element={<Comment />} />
                </Route>
                <Route path="/payments/success/product" element={<SuccessPaymentProduct />} />
                <Route path="/payments/success/crowdfunding" element={<SuccessPaymentCrowdFunding />} />
                <Route path="/payments/success/ticket" element={<SuccessPaymentTicket />} />
            </Route>

            <Route path="/charts/top-vista-compartir-cancion/:id" element={<TopViewShareCard />} />
            <Route
                path="/charts/top-vista-compartir-artista/:id"
                element={<TopViewShareArtistCard />}
            />
            <Route
                path="/charts/top-vista-compartir-tarjeta/:id/:type?"
                element={<TopViewShareMainCard />}
            />

            <Route path="/tv" element={<TV />}>
                <Route index element={<MainTV />} />
            </Route>
            <Route path="auth">
                <Route index="index" element={<SignIn />} />
                <Route exact path="/auth/sign-up" element={<SignUp />} />
                <Route exact path="/auth/sign-out" element={<SignOut />} />
            </Route>
            <Route path="/confirm-email" element={<ConfirmEmail />} />
            <Route path="/recuperar-contrasena" element={<RecoverPassword />} />
            <Route path="/solicitar-recuperar-contrasena" element={<RequestPasswordRecovery />} />
            <Route path="/details/:type/:profileId" element={<Profile />} />
            <Route path="/details/community/:type/:profileId" element={<CommunityProfile />} />

            <Route path="/preview/artist">
                <Route
                    exact
                    index="index"
                    path="/preview/artist/propuesta-1"
                    element={<TemplatePerfil1 />}
                />
                <Route
                    exact
                    index="index"
                    path="/preview/artist/propuesta-2"
                    element={<TemplatePerfil2 />}
                />

                <Route
                    exact
                    index="index"
                    path="/preview/artist/propuesta-3"
                    element={<TemplatePerfil3 />}
                />
            </Route>
            <Route path="/preview/professional">
                <Route
                    exact
                    index="index"
                    path="/preview/professional/propuesta-1"
                    element={<TemplateProfessionalPerfil1 />}
                />
                <Route
                    exact
                    index="index"
                    path="/preview/professional/propuesta-2"
                    element={<TemplatePerfil2 />}
                />
                <Route
                    exact
                    index="index"
                    path="/preview/professional/propuesta-3"
                    element={<TemplateProfessionalPerfil3 />}
                />
            </Route>
            {/* <Route
                path="/preview/user/propuesta-1"
                element={<Navigate replace to="/preview/user/propuesta-1#home" />}
            /> */}
            <Route path="/preview/user/propuesta-1" element={<TemplateUserProfile1 />} />
            <Route path="/preview/user/propuesta-2" element={<TemplateUserProfile2 />} />
            <Route path="/preview/user/propuesta-3" element={<TemplateUserProfile3 />} />
            <Route path="/preview/community/professional" element={<TemplateCommunity />} />
            <Route path="/preview/community/user" element={<TemplateCommunity />} />
            <Route path="*" element={<NotFound />} />
        </>,
    ),
);

const AppRoutes = () => {
    return <RouterProvider router={router} />;
};

export default AppRoutes;
